import { useContext } from "react";
import ReusableTabs from "../../components/tabs/tabs";
import AppLayout from "../../layouts/app-layout";
import { AdminStyled } from "./admin.styles";
import BlockOffs from "./tabs-content/blockoffs/blockoffs";
import InviteUsers from "./tabs-content/invite-users/invite-users";
import Notify from "./tabs-content/notify/notify";
import TimeAdjustments from "./tabs-content/time-adjustments/time-adjustments";
import ReserveTimeAdjustments from "./tabs-content/reserve_data/reserve-data";
import Settings from "./tabs-content/settings/settings";
import { GlobalContext } from "../../context/GlobalProvider";
import { ProviderResponse } from "../../types/common-types";
import TravelClients from "./tabs-content/travel-clients/travel-clients";
import RescheduleScheduleTab from "./tabs-content/reschedule-schedule/reschedule-schedule";
import ProviderSchedules from "./tabs-content/provider-schedules/provider-schedules";

const tabs = (providersAppointmentData: ProviderResponse[]) => [
  { label: "Time Adjustments", content: <TimeAdjustments /> },
  { label: "Reserve Data", content: <ReserveTimeAdjustments /> },
  {
    label: "Blockoffs",
    content: <BlockOffs providersAppointmentData={providersAppointmentData} />,
  },
  { label: "Travel Clients", content: <TravelClients /> },
  {
    label: "Notify",
    content: <Notify providersAppointmentData={providersAppointmentData} />,
  },
  { label: "Invite Users", content: <InviteUsers /> },
  { label: "Reschedule", content: <RescheduleScheduleTab /> },
  {
    label: "Provider Schedules",
    content: <ProviderSchedules providersAppointmentData={providersAppointmentData} />,
  },
  { label: "Settings", content: <Settings /> },
];

const Admin = () => {
  const { providersAppointmentData } = useContext(GlobalContext);
  return (
    <AppLayout>
      <AdminStyled className="admin-wrapper">
        <ReusableTabs tabs={tabs(providersAppointmentData)} />
      </AdminStyled>
    </AppLayout>
  );
};

export default Admin;
